var map = {
	"./Entrepreneurship .svg": 160,
	"./Ivo-1.jpg": 161,
	"./Lancaster-Uni.png": 162,
	"./Predictive analysis.svg": 163,
	"./address_image.svg": 164,
	"./ag_logo.jpeg": 165,
	"./animated_ashutosh.png": 166,
	"./animated_logo.svg": 167,
	"./aw_logo.jpeg": 168,
	"./bhv.png": 169,
	"./blogs_image.svg": 170,
	"./bots.svg": 171,
	"./bsgc_logo.svg": 172,
	"./btc-man.png": 93,
	"./canary.jpeg": 173,
	"./cfa.png": 174,
	"./cloud_infrastructure.svg": 175,
	"./codeInLogo.png": 176,
	"./coderus_logo.png": 177,
	"./contactMail.png": 178,
	"./coursera.png": 179,
	"./coursera_logo.png": 180,
	"./cruzroja.jpeg": 181,
	"./data_science.svg": 182,
	"./datachain.png": 183,
	"./db_logo.jpeg": 184,
	"./deeplearning_ai_logo.png": 185,
	"./delhivery_logo.png": 186,
	"./developerActivity.svg": 187,
	"./dsc_logo.png": 188,
	"./education.svg": 189,
	"./experience.svg": 190,
	"./feelingProud.svg": 191,
	"./freecopy_logo.png": 192,
	"./fullstack.svg": 193,
	"./gcp_logo.png": 194,
	"./github_logo.png": 195,
	"./gledus_logo.jpeg": 196,
	"./googleAssistant.jpg": 197,
	"./googleAssistant.svg": 198,
	"./google_logo.png": 199,
	"./heidelberg.png": 200,
	"./ibm_logo.png": 201,
	"./intel_logo.jpg": 202,
	"./iss_logo.png": 203,
	"./ivo-nft-big.png": 204,
	"./ivo-nft.png": 71,
	"./jb.png": 205,
	"./jp.png": 206,
	"./jsFramework.svg": 207,
	"./lancasteruni.png": 208,
	"./legato_logo.png": 209,
	"./lu-logo2.svg": 210,
	"./lu_logo.png": 211,
	"./lu_logo2.png": 212,
	"./lucareers_logo.png": 213,
	"./magknit_logo.jpeg": 214,
	"./manOnTable.svg": 215,
	"./microsoft_logo.png": 216,
	"./mozilla_logo.png": 217,
	"./muffito_logo.png": 218,
	"./mundocrypto.png": 219,
	"./nextuLogo.jpg": 220,
	"./ngo.jpeg": 221,
	"./nptel_logo.png": 222,
	"./phantom.jpeg": 223,
	"./portfolio.gif": 224,
	"./programmer.svg": 225,
	"./projects_image.svg": 226,
	"./purdue.png": 227,
	"./pwa.png": 228,
	"./saayaHealthLogo.png": 229,
	"./scc_logo.jpeg": 230,
	"./scrum.png": 231,
	"./sidd_logo.jpeg": 232,
	"./sidd_logo.png": 233,
	"./sidd_logo2.png": 234,
	"./sidd_logo3.png": 235,
	"./sidd_logo4.png": 236,
	"./sidd_logo5.png": 237,
	"./sidd_logo6.png": 238,
	"./siddhi.png": 239,
	"./siddhi2.png": 240,
	"./stanford_logo.png": 241,
	"./talksCardBack.svg": 242,
	"./talksCardBackAlt.svg": 243,
	"./tiny-people-turning-bulb-into-socket-idea-lamp-electricity-flat-vector-illustration-brainstorming-creativity_74855-8630.jpeg": 244,
	"./tutorful_logo.png": 245,
	"./ui_ux_design.svg": 246,
	"./undraw_conference_speaker_re_1rna.svg": 247,
	"./undraw_thought_process_re_om58.svg": 248,
	"./unibuddy_logo.png": 249,
	"./vvp.svg": 250,
	"./wqu.png": 251
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 53;